package com.example.mystybag.sharedmodels.project.responseModels.merchant

import com.example.mystybag.sharedmodels.base.BaseResponseModel
import kotlinx.serialization.Serializable

@Serializable
data class LoginMerchantResponseModel(
    val merchantId: Long = 0L,
    val jwt: String = "",
    val merchantStatus: Int = 0,
    // Menu data (optional - can be loaded separately via getMerchantMenuData)
    val iban: String? = null,
    val ibanConfirmationDate: String? = null, // Date when IBAN was confirmed (ISO format)
    val companyName: String? = null,
    val companyResponsiblePersons: List<CompanyResponsiblePersonResponseItem> = emptyList()
) : BaseResponseModel()

